<template>
  <section class="selected-test-preview" id="blood-panel-test-preview">
    <div class="icons-close">
      <div v-if="showTab('CLINICAL_CHEMISTRY', ['ALLERGY_TEST_PANEL'])">
        <div>
          <div class="custom-tabs-label">
            <span> Allergy Test Panel </span>
          </div>
        </div>
        <div class="test-panels-blocks">
          <ul>
            <li
              class="toxicology-text-panels"
              v-for="(category, index) of getCaseCategoryBasedData(
                test.case_type_code,
                ['ALLERGY_TEST_PANEL']
              )"
              :key="index"
            >
              <h3 class="test-group-title">{{ category.category }}</h3>
              <ul class="check-list-toxicology">
                <li
                  v-for="(item, index) of getCategoryWiseTestsData(
                    category.case_type_code,
                    category.category_code
                  )"
                  :key="index"
                >
                  <span>{{ item.name }} </span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div
        v-for="(category, index) of getCaseCategoryData(test.case_type_code)"
        :key="index"
      >
        <div>
          <div class="custom-tabs-label">
            <span>{{ category.category }}</span>
          </div>
        </div>

        <div class="test-panels-blocks">
          <ul class="check-list">
            <li
              v-for="(item, index) of getCategoryWiseTestsData(
                category.case_type_code,
                category.category_code
              )"
              :key="index"
            >
              <span>{{ item.name }} </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";
export default {
  mixins: [UserPermissionsHelper, AppHelper],
  components: {},
  props: ["panelTestsData", "test", "allSelectedTests"],

  data() {
    return {
      BloodPanels: [],
      selectedBloodPanels: [],
      testsData: [],
      existed: [],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup:[]
      },
      allTests: "",
    };
  },
  async mounted() {
    this.panelsTestsData = this.panelTestsData;
    this.allTests = this.allSelectedTests;
    try {
      await this.$store.dispatch("cases/fetchCoriellTestsOfPanel", {
        lab_id: this.getUserPrimaryLabId,
        case_type: "CLINICAL_CHEMISTRY",
      });
      this.BloodPanels =
        this.getCorriellTestPanels && this.getCorriellTestPanels.data
          ? this.getCorriellTestPanels.data
          : [];

      this.setSelectedCoriellPanels();

      // eslint-disable-next-line no-empty
    } catch (err) {
      console.log(err);
    }
    this.testsData = JSON.parse(
      JSON.stringify(this.panelsTestsData.selectedTestIds)
    );
    this.selectedCoriellPanels = JSON.parse(
      JSON.stringify(this.panelsTestsData.selectedCoriellPanels)
    );
  },
  computed: {
    ...mapGetters("sendOuts", ["getSendOutInformation"]),
    ...mapGetters("auth", ["getAuthenticatedUser","getUserPrimaryLabId"]),

    getTestsInformationObject() {
      const obj = {};
      if (this.allTests) {
        this.allTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },
    selectedTestsDetails() {
      const data = [];
      if (this.panelsTestsData.selectedTestIds) {
        this.panelsTestsData.selectedTestIds.forEach((el) => {
          if (el && this.getTestsInformationObject[el]) {
            data.push(this.getTestsInformationObject[el]);
          }
        });
      }

      return data;
    },
  },
  methods: {
    setSelectedCoriellPanels() {
      this.selectedBloodPanels = [];
      this.existed = [...this.panelsTestsData.selectedCoriellPanels];
      let selectedWoundPanelValue =
        this.panelsTestsData.selectedCoriellPanels.find(
          (e) => e.case_type === "CLINICAL_CHEMISTRY"
        );

      if (selectedWoundPanelValue) {
        selectedWoundPanelValue.test_panels.forEach((panel) => {
          let selectedWoundPanel = this.BloodPanels.find(
            (x) => x.code == panel
          );
          this.selectedBloodPanels.push(selectedWoundPanel);
        });
      }
    },
    getCategoryWiseTestsData(caseType, category) {
      const data = this.selectedTestsDetails.filter(
        (el) => el.case_type_code === caseType && el.category_code === category
      );
      return data;
    },
    getCaseCategoryData(caseType) {
      let data = this.selectedTestsDetails.filter(
        (el) => el.case_type_code === caseType
      );
      let category = "ALLERGY_TEST_PANEL";
      data = data.filter(
        (el) =>
          el.case_type_code &&
          el.case_type_code === caseType &&
          category.indexOf(el.parent_category_code) == -1
      );
      let flags = [],
        output = [],
        outputWithFullDetails = [],
        l = data.length,
        i;
      for (i = 0; i < l; i++) {
        if (flags[data[i].category_code]) continue;
        flags[data[i].category_code] = true;
        output.push(data[i].category_code);
        outputWithFullDetails.push(data[i]);
      }
      return outputWithFullDetails;
    },
    showTab(caseType, category, include = true) {
      if (include) {
        return this.selectedTestsDetails.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.parent_category_code) != -1
        ).length
          ? true
          : false;
      } else {
        return this.selectedTestsDetails.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.category_code) == -1
        ).length
          ? true
          : false;
      }
    },
    getCaseCategoryBasedData(caseType, category, include = true) {
      let data = "";
      if (include) {
        data = this.selectedTestsDetails.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.parent_category_code) != -1
        );
      } else {
        data = this.selectedTestsDetails.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.category_code) == -1
        );
      }

      let flags = [],
        output = [],
        outputWithFullDetails = [],
        l = data.length,
        i;
      for (i = 0; i < l; i++) {
        if (flags[data[i].category_code]) continue;
        flags[data[i].category_code] = true;
        output.push(data[i].category_code);
        outputWithFullDetails.push(data[i]);
      }
      return outputWithFullDetails;
    },
  },
};
</script>
<style lang="scss">
#blood-panel-test-preview {
  .test-panels-blocks {
    .toxicology-text-panels {
      padding: 10px 0;
      position: relative;
    }
    .toxicology-text-panels:not(:last-child):after {
      content: "";
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      border-bottom: 1px solid #e8e4e4;
    }
    .check-list-toxicology {
      display: grid;
      grid-template-columns: repeat(5, 19%);
      -moz-column-gap: 10px;
      column-gap: 10px;
      li {
        margin: 7px 0;

        &:not(:last-child) {
          margin-right: 15px;
        }
      }
      .el-checkbox {
        height: auto;
      }
      .el-checkbox-group {
        .el-checkbox {
          height: 20px;
        }
        .el-checkbox__input .el-checkbox__inner {
          border-color: transparent;
          box-shadow: 0 0 0 1px #ced1d6;
          border-radius: 4px;
          width: 17px;
          height: 17px;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #273480;
          border-color: #ffffff;
          box-shadow: 0 0 0 1px #ced1d6;
          width: 17px;
          height: 17px;
        }
        .el-checkbox__inner::after {
          box-sizing: content-box;
          content: "";
          border: 2px solid var(--el-checkbox-checked-icon-color);
          border-left: 0;
          border-top: 0;
          height: 9px;
          left: 5px;
          position: absolute;
          top: 1px;
          transform: rotate(45deg) scaleY(1);
          width: 3px;
          transition: transform 0.15s ease-in 50ms;
          transform-origin: center;
        }
        .el-checkbox__label {
          color: #34495e;
        }
      }
    }
    .test-group-title {
      font-size: 16px;
      color: #333;
      margin-bottom: 5px;
    }
  }
}
</style>
